import React from 'react';
import { FormEdit } from '../../common/components/FormEdit';
import DatetimeInput, { formatUtc } from '../../common/components/inputs/Datetime';
import TextInput from '../../common/components/inputs/Text';
import { CompetitionInputCollection } from '../../footdata/competitions/CompetitionInputCollection';
import { MatchInputCollection } from '../../footdata/matches/MatchInputCollection';
import { PersonInputCollection } from '../../footdata/people/PersonInputCollection';
import { TeamInputCollection } from '../../footdata/teams/TeamInputCollection';
import SelectConstant from '../components/constants/Select';

interface IProps {
  data: any;
  onSubmit: (form: any) => any;
}

export class MatchPushForm extends React.Component<IProps> {
  private config = {
    fields: [
      'text',
      'title',
      'system',
      'segment',
      'scheduledAt',
      'excludedFootdataCompetitionIds',
      'excludedFootdataTeamIds',
      'excludedFootdataMatchIds',
      'excludedFootdataPersonIds',
      'footdataCompetitionIds',
      'footdataTeamIds',
      'footdataMatchIds',
      'footdataPersonIds',
    ],
    disposition: [
      {
        fields: [
          {
            name: 'title',
            component: TextInput,
          },
          {
            name: 'text',
            component: TextInput,
            multiline: true,
            validate: value => !value && 'error_required',
          },
          {
            name: 'segment',
            component: SelectConstant,
            entity: 'pushFDA',
            size: 6,
          },
          {
            name: 'system',
            component: SelectConstant,
            entity: 'pushFDA',
            size: 6,
            allable: true,
          },
          {
            name: 'scheduledAt',
            component: DatetimeInput,
            normalize: formatUtc,
            size: 6,
            helperKey: 'field_scheduledAtHelper',
          },
        ],
      },
      {
        size: 6,
        title: 'form_dataToExclude',
        fields: [
          {
            name: 'excludedFootdataCompetitionIds',
            component: CompetitionInputCollection,
          },
          {
            name: 'excludedFootdataTeamIds',
            component: TeamInputCollection,
          },
          {
            name: 'excludedFootdataMatchIds',
            component: MatchInputCollection,
          },
          {
            name: 'excludedFootdataPersonIds',
            component: PersonInputCollection,
          },
        ],
      },
      {
        size: 6,
        title: 'form_dataToLink',
        fields: [
          {
            name: 'footdataCompetitionIds',
            component: CompetitionInputCollection,
          },
          {
            name: 'footdataTeamIds',
            component: TeamInputCollection,
          },
          {
            name: 'footdataMatchIds',
            component: MatchInputCollection,
          },
          {
            name: 'footdataPersonIds',
            component: PersonInputCollection,
          },
        ],
      },
    ],
  };

  public render() {
    const { data, onSubmit } = this.props;

    return (
      <FormEdit
        key="push"
        form="push"
        onSubmit={onSubmit}
        data={data}
        config={this.config}
        useUserRestriction
        main
      />
    );
  }
}
